import { render } from "./LabelScrap.vue?vue&type=template&id=be835c6e&scoped=true"
import script from "./LabelScrap.vue?vue&type=script&lang=js"
export * from "./LabelScrap.vue?vue&type=script&lang=js"

import "./LabelScrap.vue?vue&type=style&index=0&id=be835c6e&lang=scss&scoped=true"

import exportComponent from "/Users/leopons/Desktop/Projects/cryptos/bubble-graph/bubblemaps-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be835c6e"]])

export default __exports__